import React, { useState } from 'react';
import { ManageMechantTable } from '../..';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import './index.css';
import { SelectInput } from '../../../Components';
const ManageMerchants = () => {
    const [rowPerPage, setRowPerPage] = useState(10);
    return (
        <div className="manage_orders_merch">
            <div className="manage_orders_merch_head">
                <h2>MANAGE MERCHANTS</h2>
            </div>
            <div className="manage_orders_merch_body">
                <ManageMechantTable />
            </div>
            <div className="pagination_footer">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectInput
                        marginZero
                        style={{ minWidth: '30px' }}
                        label="Rows per page:"
                        value={rowPerPage}
                        changeHandler={(e) => {
                            setRowPerPage(e.target.value);
                        }}
                        options={[
                            { name: '10', value: 10 },
                            { name: '25', value: 25 },
                            { name: '50', value: 50 },
                        ]}
                    />
                </div>
                <div className="pagination_footer_pageinfo">
                    <p className="page_details">1-6 of 6</p>
                    <div>
                        <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                        <ChevronRightIcon className={`footer_pagination_icon`} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageMerchants;
